export const getOfflineCbtGoalUid = (cbtConfig) =>
  cbtConfig?.cbtOfflineGoalProgramMap?.cbtGoalUid ?? null;

export const getCbtOfflineProgrammeUid = (cbtConfig) =>
  cbtConfig?.cbtOfflineGoalProgramMap?.programUid ?? null;

export const isCbtVenueConfigReady = (cbtConfig) =>
  !!(getOfflineCbtGoalUid(cbtConfig) && getCbtOfflineProgrammeUid(cbtConfig));

export const isOfflineCbtAddon = (bundle, cbtConfig) => {
  const offlineCbtGoalUid = getOfflineCbtGoalUid(cbtConfig);
  if (!bundle || !offlineCbtGoalUid || !isCbtVenueConfigReady(cbtConfig)) {
    return false;
  }

  return bundle.topology_details?.some(
    (topology) => topology.uid === offlineCbtGoalUid
  );
};
